export default __webpack_public_path__ + "static/media/PowerButtonHover.6cee373c.svg";